import { Grid } from '@mui/material';
import { GameEntity } from '@okletsplay/core';
import { GameCard } from 'modules/matches/components/GameCard';
import React, { FC, useCallback } from 'react';

interface GameSelectionProps {
  games: GameEntity[];
  value?: string;
  onChange: (value: string) => void;
  cardColor?: string;
}

export const GameSelection: FC<GameSelectionProps> = ({ games, value, onChange, cardColor }) => {
  const selectGame = useCallback(
    (selectedGame: GameEntity) => {
      onChange(selectedGame.id);
    },
    [onChange]
  );

  return (
    <Grid
      container
      spacing={2}
      sx={{ display: 'grid' }}
      gridTemplateColumns="repeat(auto-fill, minmax(min(100%, 300px), 1fr))"
    >
      {games.map((game: GameEntity) => (
        <Grid item key={game.id}>
          <GameCard
            game={game}
            onChange={selectGame}
            isActive={game.id === value}
            cardColor={cardColor}
          />
        </Grid>
      ))}
    </Grid>
  );
};
